import uuidv4 from 'uuid/v4';
import _ from 'lodash';
/**
 * Generates a RFC4122 version 4 compliant GUID
 * Source: https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
 */
export function generateGuid() {
    return uuidv4();
}
export function generateRandomUniquePropertyName() {
    return "id_" + generateGuid().replace(/-/g, '');
}
export function generateRandomInteger(min, max) {
    return _.random(min, max);
}
export function getRandomItem(array) {
    return array[generateRandomInteger(0, array.length - 1)];
}
//# sourceMappingURL=RandomGenerator.js.map